import { topics } from "@/mocks/chiguaHome";

const trendIcon: Record<string, string> = {
  up: "ri-arrow-up-line text-emerald-600",
  flat: "ri-subtract-line text-stone-400",
  down: "ri-arrow-down-line text-rose-500",
};

export default function TopicGrid() {
  return (
    <section id="topics" className="scroll-mt-20 border-y border-stone-200/70 bg-white">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-16">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-widest text-orange-700">
              <i className="ri-grid-fill"></i> Direct Access
            </span>
            <h2 className="mt-2 text-2xl font-extrabold tracking-tight text-stone-900 md:text-3xl">
              分类直达 <span className="text-orange-600">·</span> 想聊啥点啥
            </h2>
            <p className="mt-2 max-w-xl text-sm text-stone-500">
              按题材分好大类，每类带当前话题数与趋势，直接进对应讨论区，不用层层翻找。
            </p>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
          {topics.map((t) => (
            <a
              key={t.name}
              href="#topics"
              className="group flex items-start gap-3 rounded-xl border border-stone-200 bg-[#fdfbf6] p-4 transition-colors hover:border-orange-300 hover:bg-orange-50/60"
            >
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-orange-100 text-orange-700 transition-colors group-hover:bg-orange-600 group-hover:text-white">
                <i className={`${t.icon} text-lg`}></i>
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex items-center justify-between gap-2">
                  <h3 className="whitespace-nowrap text-sm font-bold text-stone-900">{t.name}</h3>
                  <i className={`${trendIcon[t.trend]} text-sm`}></i>
                </div>
                <p className="mt-0.5 truncate text-xs text-stone-500">{t.desc}</p>
                <p className="mt-2 text-[11px] font-semibold text-stone-400">{t.count} 话题</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}